import PropTypes from 'prop-types';
import { SENTIMENTS } from '../watchlist/constants';
import { verdictShape } from '../watchlist/propShapes';

export const alertShape = PropTypes.shape({
    monitorId: PropTypes.string.isRequired,
    sessionId: PropTypes.string,
    title: PropTypes.string,
    verdict: verdictShape.isRequired,
    lastRunAt: PropTypes.string,
    identity: PropTypes.number.isRequired,
    sentiment: PropTypes.oneOf(Object.values(SENTIMENTS)),
    flagged: PropTypes.bool.isRequired,
    isUnread: PropTypes.bool.isRequired,
});
